<div class="w-full h-[100vh] flex justify-center lg:grid lg:grid-cols-[60%_1fr] sm:p-[20px] lg:p-[45px] wrapper-bg">
  <div class="w-full hidden lg:flex flex-col">
    <!-- <div class="w-full hidden h-full md:flex flex-col p-[35px] gap-[50px]"> -->
    <div><img class="max-w-[180px]" src="../../../assets/icons/secureProxy_white.svg" alt="" /></div>
    <div class="w-full h-full flex flex-col gap-[10px] justify-end">
      <!-- <span class="text-[50px] font-[700] text-[#fff]">Secure Proxy</span> -->
      <!-- <div class="typing-effect">
        {{ currentText }}<span class="cursor">|</span>
      </div> -->
    </div>
  </div>
  <div class="w-full flex flex-col overflow-y-auto bg-[#fff] sm:rounded-[20px] sm:max-w-[500px]">
    <img class="max-w-[130px] ms-[40px] mt-[40px] lg:hidden flex " src="../../../assets/icons/secureProxy_blue.svg" alt="">
  <div
    class="w-full h-full flex flex-col overflow-y-auto items-center lg:items-start sm:px-[40px] p-[20px] gap-[40px]"
  >
  <div class="flex w-full flex-col gap-[5px]">
    <div *ngIf="registerPage > 1" (click)="toPreviousStep()" class="flex items-center cursor-pointer"><img src="../../../assets/icons/chevron-left2.svg" alt=""><span class="font-[700] text-[14px] text-slate-600">Back</span></div>
      <span class="text-[28px] font-[700]">Create An Account!</span>
      <span class="text-[16px] font-[700] text-slate-600">{{registerPage == 1 ? 'User Data' : 'Organizational Data'}}</span>
    </div>
    <div class="flex flex-col w-full gap-[20px]">
      <div class="flex flex-col gap-[10px] w-full">
        <div *ngIf="registerPage == 1" class="w-full">
          <div class="w-full flex flex-col">
            <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-[20px]">
              <app-input [label]="'First Name'" [placeholder]="'Enter first name'" [error]="errors.firstName" [title]="'firstName'" (returnValue)="handleInput($event)" [inputValue]="registerData.firstName" />
              <app-input [label]="'Last Name'" [placeholder]="'Enter last name'" [error]="errors.lastName" [title]="'lastName'" (returnValue)="handleInput($event)" [inputValue]="registerData.lastName" />
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-[20px]">
              <app-input [label]="'Email Address'" [placeholder]="'Enter email address'" [error]="errors.emailAddress" [title]="'emailAddress'" (returnValue)="handleInput($event)" [inputValue]="registerData.emailAddress" />
              <app-input [label]="'Phone Number'" [placeholder]="'Enter phone number'" [error]="errors.phoneNumber" [title]="'phoneNumber'" (returnValue)="handleInput($event)" [inputValue]="registerData.phoneNumber" />
            </div>
            <app-input [label]="'Password'" [placeholder]="'Enter password'" [error]="errors.password" [type]="'password'" [title]="'password'" (returnValue)="handleInput($event)" [inputValue]="registerData.password" />
            <app-input [label]="'Confirm Password'" [placeholder]="'Confirm password'" [error]="errors.verifyPassword" [title]="'verifyPassword'" (returnValue)="handleInput($event)" [type]="'password'" [inputValue]="verifyPassword" />
          </div>
        </div>
        <div *ngIf="registerPage == 2" class="w-full">
          <div class="w-full">
            <app-input [label]="'Name'" [placeholder]="'Enter business name'" [title]="'organizationName'" [error]="errors.organizationName" (returnValue)="handleInput($event)" [inputValue]="registerData.organizationName" />
            <app-input [label]="'Registration Country'" [placeholder]="'Enter country'" [title]="'registrationCountry'" [error]="errors.registrationCountry" (returnValue)="handleInput($event)" [inputValue]="registerData.registrationCountry"  />
            <div>
              <div class="w-full grid grid-cols-1 sm:grid-cols-2 sm:gap-[20px]">
                <app-input [label]="'Email'" [placeholder]="'Enter email address'" [title]="'organizationEmailAddress'" [error]="errors.organizationEmailAddress" (returnValue)="handleInput($event)" [inputValue]="registerData.organizationEmailAddress" />
                <app-input [label]="'Phone Number'" [placeholder]="'Enter phone number'" [title]="'organizationPhoneNumber'" [error]="errors.organizationPhoneNumber" (returnValue)="handleInput($event)" [inputValue]="registerData.organizationPhoneNumber" />
               </div>
            </div>
             <div class="w-full grid grid-cols-1 sm:grid-cols-[65%_30%] sm:gap-[20px]">
              <app-input [label]="'Street'" [placeholder]="'Enter street'" [title]="'street'" [error]="errors.street" (returnValue)="handleInput($event)" [inputValue]="registerData.street" />
              <app-input [label]="'City'" [placeholder]="'Enter city'" [title]="'city'" [error]="errors.city" (returnValue)="handleInput($event)" [inputValue]="registerData.city" />
             </div>
             <div class="w-full grid grid-cols-1 sm:grid-cols-2 sm:gap-[20px]">
              <app-input [label]="'State'" [placeholder]="'Enter state'" [title]="'state'" [error]="errors.state" (returnValue)="handleInput($event)" [inputValue]="registerData.state" />
              <app-input [label]="'Country'" [placeholder]="'Enter country'" [title]="'country'" [error]="errors.country" (returnValue)="handleInput($event)" [inputValue]="registerData.country" />
             </div>
            <app-input [label]="'Website URL'" [placeholder]="'Enter URL'" [title]="'websiteUrl'" [error]="errors.websiteUrl"  (returnValue)="handleInput($event)" [inputValue]="registerData.websiteUrl" />
          </div>
        </div>
        <app-button
          [label]="registerPage == 1 ? 'Next' : 'Register'"
          (onClick)="registerPage == 1 ? toNextStep() : register()"
          [loading]="loading"
          [className]="
            'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
          "
        />
        <div class="w-full flex justify-start">
          <span class="text-[12px] font-[500]"
            >Already have an account?
            <span (click)="routeTo('login')" class="font-[600] text-slate-500 cursor-pointer"
              >Login</span
            ></span
          >
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
